export default {"src":"/frontend-static/_next/static/media/amazonpayLight.6e3b8ac5.svg","height":60,"width":100,"blurWidth":0,"blurHeight":0};